<template>
  <!--begin::Form-->
  <form class="m-form m-form--fit m-form--label-align-right">
    <div class="m-portlet__body">
      <div class="form-group m-form__group row text-center">
        <label class="col-form-label col-lg-3 col-md-12 col-sm-12">{{ $t('support.Subject') }}</label>
        <div class="col-lg-9 col-md-12 col-sm-12">
          <input
            v-model="contact.subject"
            type="text"
            class="form-control m-input m-input--solid"
            aria-describedby="emailHelp"
            :placeholder="$t('support.Subject')"
          >
        </div>
      </div>
      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-md-12 col-sm-12">{{ $t('support.Comments') }}</label>
        <div class="col-lg-9 col-md-12 col-sm-12">
          <textarea
            v-model="contact.body"
            rows="8"
            class="form-control m-input--solid"
            :placeholder="$t('support.Comments')"
          />
        </div>
      </div>
    </div>
    <div class="m-portlet__foot m-portlet__foot--fit">
      <div class="m-form__actions m-form__actions">
        <button
          type="button"
          class="btn btn-brand pull-right"
          @click.prevent="sendContactForm"
        >
          {{ $t('support.Submit')
          }}
        </button>
      </div>
    </div>
  </form>
  <!--end::Form-->
</template>

<script>

export default {
    props: [ 'contact', 'sendContactForm', 'subject' ],
};
</script>
